import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import IntegrationVisor from './IntegrationVisor';
import IntegationConfig from './IntegationConfig';
import IntegrationReport from './IntegrationReport';
import IntegrationDictionaryKpi from './IntegrationDictionaryKpi';
import './style.css';

function App() {
  const { t } = useTranslation();
  const [activeComponent, setActiveComponent] = useState('IntegrationVisor');

  const renderComponent = () => {
    switch (activeComponent) {
      case 'IntegrationVisor':
        return <IntegrationVisor />;
      case 'IntegationConfig':
        return <IntegationConfig />;
      case 'IntegrationReport':
        return <IntegrationReport />;
      case 'IntegrationDictionaryKpi':
        return <IntegrationDictionaryKpi />;
      default:
        return <IntegrationVisor />;
    }
  };

  return (
    <div className="app d-flex">
      <aside className="menu card rounded">
        <ul className="list-group list-group-flush">
          <li
            className={`list-group-item ${activeComponent === 'IntegrationVisor' ? 'active' : ''}`}
            onClick={() => setActiveComponent('IntegrationVisor')}
          >
            {t('data-lang-lbl-menu_integration-visor')}
          </li>
          <li
            className={`list-group-item ${activeComponent === 'IntegationConfig' ? 'active' : ''}`}
            onClick={() => setActiveComponent('IntegationConfig')}
          >
            {t('data-lang-lbl-menu_integration-config')}
          </li>
          <li
            className={`list-group-item ${activeComponent === 'IntegrationReport' ? 'active' : ''}`}
            onClick={() => setActiveComponent('IntegrationReport')}
          >
            {t('data-lang-lbl-menu_integration-report')}
          </li>
          <li
            className={`list-group-item ${activeComponent === 'IntegrationDictionaryKpi' ? 'active' : ''}`}
            onClick={() => setActiveComponent('IntegrationDictionaryKpi')}
          >
            {t('data-lang-lbl-menu_integration-dictionary')}
          </li>
        </ul>
      </aside>
      <main className="content flex-grow-1 p-3">
        {renderComponent()}
      </main>
    </div>
  );
}

export default App;
